export class Actions {
  uId: string;
  aID: string;
  actionKey: string;
  name: string;

  description: string;
 
}
